"use client";
import React from "react";
import { cn, useBooleanState } from "@gettactic/helpers";
import { LoadingSpinner } from "@cmp-src/loadings/LoadingSpinner";

export const MapLoadingSpinner: React.FC = () => {
  const showLoading = useBooleanState();

  React.useEffect(() => {
    showLoading.false();
    const timeout = setTimeout(() => {
      showLoading.true();
    }, 3000); // show after 1 seconds

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div
      className={cn(
        "flex h-full min-h-40 w-full min-w-40 items-center justify-center px-6 py-4 transition-opacity",
        !showLoading.state ? "opacity-0" : "opacity-100"
      )}
    >
      <LoadingSpinner />
    </div>
  );
};
